import React from 'react';
import {RenderIcon} from '../../components/Icons';
import UIButton from '../../../../../globalComponents/UIComponents/UIButton';
import { useLocaleContext } from '../../../../../platform/src/context/LocaleContext';

const NotificationsFooter = ({eventKey}) => {
    const $locale = useLocaleContext();

    return (
        <div className='registration-nofification__footer'>
            <p className='registration-nofification__footer-prompt'>
                {$locale.get('registration.calendars.prompt')}
            </p>
            <UIButton
                style="calendar"
                onClick={() => window.open(`/api/player/event/${eventKey}/calendar.ics?locale=${$locale.name}&hideAddress=true`, '_blank')}
            >
                {<RenderIcon iconName="CalendarIcon" />}
                {$locale.get('notification-subscribe.calendar.submit')}
            </UIButton>
        </div>
    )
};

export default NotificationsFooter;
